import i18n from '@/i18n'
import { EmailAddressField } from '@/components/shared/forms/WalletCommonFormFields'

export const WalletLoginFormSchema = {
  fields: [
    EmailAddressField,
    {
      type: 'slot',
      model: 'password',
      label: i18n.t('wallet.form.password.label')
    }
  ]
}
